import { trpcClient } from '@/lib/trpc'

export async function downloadAuditPackage(params: {
  auditCycleId: string
  packageId: string
}): Promise<void> {
  const result = await trpcClient.auditor.downloadAuditPackage.query(params)
  const anchor = document.createElement('a')
  anchor.href = result.url
  anchor.download = result.fileName || 'audit-package.zip'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}

/**
 * Fetch a zip of evidence files for the given tests (CES) and trigger a browser
 * download. Shared by the per-control "Download Evidence" button and the
 * per-test "Download All" button in the auditor center.
 */
export async function downloadCesEvidence(params: {
  auditCycleId: string
  statusIds: string[]
  label?: string
}): Promise<void> {
  const result = await trpcClient.auditor.downloadCesEvidenceZip.query(params)
  saveZipResult(result)
}

/** Turn a base64 zip payload from the API into a browser download. */
export function saveZipResult(result: {
  data: string
  contentType?: string | null
  fileName?: string | null
}): void {
  const binary = atob(result.data)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }
  const blob = new Blob([bytes], {
    type: result.contentType || 'application/zip',
  })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = result.fileName || 'evidence.zip'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
